import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { queryIdentifier } from "../api/identifierApi";
import { apiGetModuleFields, queryDefaultIdentifier } from "../api/apiFunctions";
// import { queryIdentifier } from "../apis/apiFunctions";

type IdentifiersDialogsStoreField = {
  showManageIdentifierPop: boolean;
  showSingleManageIdentifierPop: boolean;
  openBulkIdentifierDialog: boolean;
  successCount: number;
  initFilterList: any;
  associatedXevmpdId: string;//using recordId for xevmpd
  autoTagList: any[];
  defaultIdentifier: any;
  isLoading: boolean;
  disabledList: any;
  defaultAutoCheckedList: any;
  disableIdentifierList:any;
};

type IdentifiersDialogsStoreState = IdentifiersDialogsStoreField & {
  onSingleIdentifierSuccess: () => void;
  openSingleIdentifier: (newList: any, autoTagCodes: any, defaultIdentifier: any, disableIdentifierList: any, associatedApplicationId: string) => void;
  updateShowManageIdentifierPop: (newValue: boolean) => void;
  updateShowSingleManageIdentifierPop: (newValue: boolean) => void;
  updateOpenBulkIdentifierDialog: (newValue: boolean) => void;
  updateAutoTagList: (newList: any[]) => void;
  openManageIdentifierPop: () => void;
  closeManageIdentifierPop: () => void;
  closeSingleIdentifierPop: () => void;
  onBatchIdentifierSuccess: (newCount: number) => void;
  handleClickSingleIdentifier: (xevmpdId: string, identifierMap: any, setIsApiLoading: any) => Promise<void>;
};

const useIdentifiersDialogsStore = create<IdentifiersDialogsStoreState>()(
  subscribeWithSelector(
    immer((set, get) => ({
      showManageIdentifierPop: false,
      showSingleManageIdentifierPop: false,
      openBulkIdentifierDialog: false,
      successCount: 0,
      initFilterList: null,
      associatedXevmpdId: "",
      autoTagList: [],
      defaultIdentifier: null,
      isLoading: false,
      disabledList: null,
      defaultAutoCheckedList: null,
      disableIdentifierList:null,

      updateAutoTagList(newList) {
        set((state) => {
          state.autoTagList = newList;
        });
      },
      openManageIdentifierPop() {
        set((state) => {
          state.showManageIdentifierPop = true;
          state.initFilterList = null;
          state.disabledList = null;
          state.defaultAutoCheckedList = null;
        });
      },
      updateShowManageIdentifierPop(newValue) {
        set((state) => {
          state.showManageIdentifierPop = newValue;
          
        });
      },
      closeManageIdentifierPop() {
        set((state) => {
          state.showManageIdentifierPop = false;
          state.initFilterList = null;
           state.disabledList = null;
          state.defaultAutoCheckedList = null;
        });
      },
      updateShowSingleManageIdentifierPop(newValue) {
        set((state) => {
          state.showSingleManageIdentifierPop = newValue;
        });
      },
      closeSingleIdentifierPop() {
        set((state) => {
          state.showSingleManageIdentifierPop = false;
          state.initFilterList = null;
           state.disabledList = null;
          state.defaultAutoCheckedList = null;
        });
      },
      openSingleIdentifier(newList,disabledList, defaultIdentifier,autoTagList, associatedXevmpdId) {
        set((state) => {
          state.showSingleManageIdentifierPop = true;
          state.initFilterList = newList;
          state.associatedXevmpdId = associatedXevmpdId;
          state.disabledList = disabledList;
          state.disableIdentifierList=autoTagList;
          state.defaultAutoCheckedList = defaultIdentifier;
        })
      },
      onSingleIdentifierSuccess() {
        set((state) => {
          state.initFilterList = null;
          state.showSingleManageIdentifierPop = false;
        })
      },
      onBatchIdentifierSuccess(newCount) {
        set((state) => {
          state.successCount = newCount;
          state.showManageIdentifierPop = false;
          state.openBulkIdentifierDialog = true;
          state.initFilterList = null;
        });
      },
      updateOpenBulkIdentifierDialog(newValue) {
        set((state) => {
          state.openBulkIdentifierDialog = newValue;
        })
      },
      async handleClickSingleIdentifier(xevmpdId: string, identifierMap: any,setIsApiLoading:any) {
        set((state) => { state.isLoading = true; });
  
        
        const fetchIdentifier = () =>
          queryIdentifier({ xevmpdIds: [xevmpdId] }).then((data: any) => data?.data);

        const fetchAutoTagList = async () => {
          const data = await apiGetModuleFields("All", "xevmpd");
          const response = data?.data;
          if (response?.code === 200) {
            return (
              response.data
                ?.filter?.((item: any) => item.identifier)
                ?.map((item: any) => item.dataSource || item.identifierName) ?? []
            );
          }
          return [];
        };

        const queryDefault = async () => {
          const data = await queryDefaultIdentifier({
            registrationId: xevmpdId,
            identifierMeta: identifierMap,
          });

          const res = data?.data;

          if (res?.code === 200) return res.data;
          return null;
        };

        try {
          const [identifierData, autoTagData, defaultData] = await Promise.all([
            fetchIdentifier(),
            fetchAutoTagList(),
            queryDefault(),
          ]);

          const mock={
        "parentIdentifierJson": null,
        "identifierJson": "{\"Country\": [\"Country_COCO0103\"], \"ProductType\": [\"ProductType_PRTY000132\", \"ProductType_FRE-PRTY000003\"], \"ProductPhase\": [\"ProductPhase_PDPS00001\"], \"ProductFamily\": [\"ProductFamily_PTFY000019\"], \"VPVKYKWMRecordID\": [\"VPVKYKWMRecordID_FRE-BKYE004488\"]}",
        "autoTagCodesJson": "{\"VPVKYKWMRecordID\":[\"VPVKYKWMRecordID_FRE-BKYE004488\"],\"ProductType\":[\"ProductType_FRE-PRTY000003\"],\"ProductFamily\":[\"ProductFamily_PTFY000019\"],\"ProductPhase\":[\"ProductPhase_PDPS00001\"]}",
        "productId": "20003716"
    };

    const mockDefault={
        "ProductFamily": [
            "ProductFamily_PTFY000019"
        ],
        "ProductLifecycle": [
            "ProductLifecycle_TKNI000000"
        ],
        "RecordType": [
            "RecordType_JVWT000001"
        ],
        "PharmaceuticalDoseForm": [
            "PharmaceuticalDoseForm_PDF00279"
        ],
        "ProductPhase": [
            "ProductPhase_PDPS00001"
        ],
        "ProductType": [
            "ProductType_FRE-PRTY000003"
        ],
        "ProductCategory": [
            "ProductCategory_PDCY00001"
        ],
        "VPVKYKWMRecordID": [
            "VPVKYKWMRecordID_FRE-BKYE004488"
        ]
    }
          const parsedIdentifiers = JSON.parse(identifierData?.data?.identifierJson ?? "{}");
          const parsedAutoTagCodes = JSON.parse(identifierData?.data?.autoTagCodesJson ?? "{}");
          console.log("AUTOTAG DATA:",autoTagData,parsedIdentifiers,parsedAutoTagCodes,defaultData, "---handleClickSingleIdentifier---");
          get().openSingleIdentifier(
            parsedIdentifiers,
            parsedAutoTagCodes,
            defaultData,
            autoTagData,
            xevmpdId,
          );
        } catch (error) {
          console.error("handleClickSingleIdentifier error:", error);
        } finally {
          set((state) => { state.isLoading = false; });
          setIsApiLoading(false);
        }
      },
    }))
  )
);

export default useIdentifiersDialogsStore;
